<template>
  <div class="d-flex">
    <div v-if="filterByItemCodes" class="mt-5 mr-5">
      <div class="d-flex mb-3">
        <DxRadioGroup
            @initialized="saveRadioGroupInstance"
            @value-changed="onRadioGroupSelectionChanged"
            :items="['All']"
            value="All"
        >
          <template #item>
          </template>
        </DxRadioGroup>
        <div class="font-14" v-if="itemCodesAllElementCount">
          All Items ({{ itemCodesAllElementCount }})
        </div>
      </div>
      <DxList
          @initialized="saveListInstance"
          :data-source="itemCodes"
          :show-selection-controls="true"
          :selected-items.sync="selectedItemCodes"
          selection-mode="single"
          page-load-mode="scrollBottom"
          :search-enabled="true"
          @selection-changed="onSelectionChanged"
          :width="190"
          :height="height"
          style="margin-top: 13px"
      />
    </div>
    <div class="mt-3">
      <DxDataGrid
          @initialized="saveTotalGridInstance"
          class="mb-3"
          :data-source="dataSourceTotal"
          :show-borders="true"
          :column-auto-width="false"
          :rowAlternationEnabled="true"
          :showRowLines="true"
          :remoteOperations="false">
        <DxPaging :pageSize="50" />
        <DxSorting mode="none" />
        <DxColumn data-field="id" :visible="false" />
        <DxColumn data-field="jobMadeDate" caption="Időszak" dataType="date" :width="125"
                  :calculate-cell-value="jobMadeDateCellValueForTotal" alignment="center"
        />
        <DxColumn data-field="partsWeight" caption="Keletkezett alkatrész"
                  cell-template="cell-template"
        />
        <DxColumn data-field="metarialWasteWeight" caption="Elsődleges hulladék"
                  cell-template="cell-original-template-1"
        />
        <DxColumn data-field="metarialRestWeight" caption="Keletkezett maradék"
                  cell-template="cell-template"
        />
        <DxColumn data-field="usedRestWeight" caption="Felhasznált maradék"
                  cell-template="cell-template"
        />
        <DxColumn data-field="secondaryWasteWeight" caption="Felhalmozott maradék"
                  cell-template="cell-original-template-2"
        />
        <DxColumn data-field="totalWasteWeight" caption="Összes veszteség"
                  cell-template="cell-original-template-3"
        />
        <DxColumn data-field="usedMetarialWeight" caption="Felhasznált anyagmennyiség"
                  cell-template="cell-template"
        />
        <template #cell-template="{ data }">
          <CellTemplate :data="data" />
        </template>
        <template #cell-original-template-1="{ data }">
          <CellOriginalTemplate :value="data.value" :parts-weight="data.data.partsWeight" :efficiency="data.data.metarialWasteWeightEfficiency" />
        </template>
        <template #cell-original-template-2="{ data }">
          <CellOriginalTemplate :value="data.value" :parts-weight="data.data.partsWeight" :efficiency="data.data.secondaryWasteWeightEfficiency" />
        </template>
        <template #cell-original-template-3="{ data }">
          <CellOriginalTemplate :value="data.value" :parts-weight="data.data.partsWeight" :efficiency="data.data.totalWasteWeightEfficiency" />
        </template>
        <template #cell-percentage-template="{ data }">
          <CellPercentageTemplate :data="data" />
        </template>
      </DxDataGrid>
      <DxDataGrid
          @initialized="saveYearlyGridInstance"
          class="mb-3"
          :data-source="dataSourceYearly"
          :show-borders="true"
          :column-auto-width="false"
          :rowAlternationEnabled="true"
          :showRowLines="true"
          :remoteOperations="false">
        <DxPaging :pageSize="50" />
        <DxSorting mode="none" />
        <DxColumn data-field="id" :visible="false" />
        <DxColumn data-field="jobMadeDate" caption="Időszak" dataType="date"
                  :calculate-cell-value="jobMadeDateCellValueForYearly" :width="125"
                  alignment="center"
        />
        <DxColumn data-field="partsWeight" caption="Keletkezett alkatrész"
                  cell-template="cell-template"
        />
        <DxColumn data-field="metarialWasteWeight" caption="Elsődleges hulladék"
                  cell-template="cell-original-template-1"
        />
        <DxColumn data-field="metarialRestWeight" caption="Keletkezett maradék"
                  cell-template="cell-template"
        />
        <DxColumn data-field="usedRestWeight" caption="Felhasznált maradék"
                  cell-template="cell-template"
        />
        <DxColumn data-field="secondaryWasteWeight" caption="Felhalmozott maradék"
                  cell-template="cell-original-template-2"
        />
        <DxColumn data-field="totalWasteWeight" caption="Összes veszteség"
                  cell-template="cell-original-template-3"
        />
        <DxColumn data-field="usedMetarialWeight" caption="Felhasznált anyagmennyiség"
                  cell-template="cell-template"
        />
        <template #cell-template="{ data }">
          <CellTemplate :data="data" />
        </template>
        <template #cell-original-template-1="{ data }">
          <CellOriginalTemplate :value="data.value" :parts-weight="data.data.partsWeight" :efficiency="data.data.metarialWasteWeightEfficiency" />
        </template>
        <template #cell-original-template-2="{ data }">
          <CellOriginalTemplate :value="data.value" :parts-weight="data.data.partsWeight" :efficiency="data.data.secondaryWasteWeightEfficiency" />
        </template>
        <template #cell-original-template-3="{ data }">
          <CellOriginalTemplate :value="data.value" :parts-weight="data.data.partsWeight" :efficiency="data.data.totalWasteWeightEfficiency" />
        </template>
        <template #cell-percentage-template="{ data }">
          <CellPercentageTemplate :data="data" />
        </template>
      </DxDataGrid>
      <DxDataGrid
          @initialized="saveGridInstance"
          :data-source="dataSource"
          :show-borders="true"
          :column-auto-width="false"
          :rowAlternationEnabled="true"
          :showRowLines="true"
          :remoteOperations="false"
          @content-ready="onContentReady">
        <DxPaging :pageSize="50" />
        <DxSorting mode="none" />
        <DxColumn data-field="id" :visible="false" />
        <DxColumn data-field="jobMadeDate" caption="Időszak" dataType="date"
                  :calculate-cell-value="jobMadeDateCellValue" :width="125"
        />
        <DxColumn data-field="partsWeight" caption="Keletkezett alkatrész"
                  cell-template="cell-template"
        />
        <DxColumn data-field="metarialWasteWeight" caption="Elsődleges hulladék"
                  cell-template="cell-original-template-1"
        />
        <DxColumn data-field="metarialRestWeight" caption="Keletkezett maradék"
                  cell-template="cell-template"
        />
        <DxColumn data-field="usedRestWeight" caption="Felhasznált maradék"
                  cell-template="cell-template"
        />
        <DxColumn data-field="secondaryWasteWeight" caption="Felhalmozott maradék"
                  cell-template="cell-original-template-2"
        />
        <DxColumn data-field="totalWasteWeight" caption="Összes veszteség"
                  cell-template="cell-original-template-3"
        />
        <DxColumn data-field="usedMetarialWeight" caption="Felhasznált anyagmennyiség"
                  cell-template="cell-template"
        />
        <template #cell-template="{ data }">
          <CellTemplate :data="data" />
        </template>
        <template #cell-original-template-1="{ data }">
          <CellOriginalTemplate :value="data.value" :parts-weight="data.data.partsWeight" :efficiency="data.data.metarialWasteWeightEfficiency" />
        </template>
        <template #cell-original-template-2="{ data }">
          <CellOriginalTemplate :value="data.value" :parts-weight="data.data.partsWeight" :efficiency="data.data.secondaryWasteWeightEfficiency" />
        </template>
        <template #cell-original-template-3="{ data }">
          <CellOriginalTemplate :value="data.value" :parts-weight="data.data.partsWeight" :efficiency="data.data.totalWasteWeightEfficiency" />
        </template>
        <template #cell-percentage-template="{ data }">
          <CellPercentageTemplate :data="data" />
        </template>
      </DxDataGrid>      
    </div>    
  </div>
</template>

<script>
import {dataSourceNoRemoteMixin} from "@/mixins/dataSourceNoRemoteMixin";
import axios from "axios";
import CellTemplate from "@/components/CellTemplate";
import CellPercentageTemplate from "@/components/CellPercentageTemplate";
import CellOriginalTemplate from "@/components/CellOriginalTemplate";
import CustomStore from "devextreme/data/custom_store";

const months = [
  { name: 'január', value: '01' },
  { name: 'február', value: '02' },
  { name: 'március', value: '03' },
  { name: 'április', value: '04' },
  { name: 'május', value: '05' },
  { name: 'június', value: '06' },
  { name: 'július', value: '07' },
  { name: 'augusztus', value: '08' },
  { name: 'szeptember', value: '09' },
  { name: 'október', value: '10' },
  { name: 'november', value: '11' },
  { name: 'december', value: '12' },
];

const partsWeights = [];

export default {
  name: 'CommonTable',
  mixins: [
    dataSourceNoRemoteMixin
  ],
  components: {CellTemplate, CellPercentageTemplate, CellOriginalTemplate},
  data() {
    return {
      dataGridInstance: null,
      yearlyDataGridInstance: null,
      totalDataGridInstance: null,
      totalCountNum: 0,
      itemCodes: null,
      selectedItemCodes: [],
      listInstance: null,
      itemCodesAllElementCount: 0,
      dataSourceTotal: null,
      dataSourceYearly: null,
      radioGroupInstance: null,
    };
  },
  props: {
    keyword: {
      type: String,
      default: null
    },
    filterByItemCodes: {
      type: Boolean,
      default: false
    }
  },
  async created() {
    if(this.filterByItemCodes) {
      await this.fetchItemCodes();
    }
    
    await this.fetch();
    // this.getAllElementCount(this.endpoint);
  },
  async mounted() {
    
  },
  computed: {
    title: function () {
      return `${capitalize(this.keyword)} Table`;
    },
    storageKey: function () {
      return `${this.keyword}-table-storage`;
    },
    endpoint: function () {
      return `api/tables/${this.keyword}`;
    },
    height: function () {
      return '842px';
    }
  },
  methods: {
    async fetch() {
      if(!this.filterByItemCodes) {
        // try {
        //   const result = await axios.get(this.endpoint);
        //   this.dataSource = result.data.monthly;
        //   this.dataSourceTotal = [result.data.total];
        //   this.dataSourceYearly = result.data.yearly;
        // } catch (e) {
        //   this.showError = true;
        //   this.errorMessage = `Error while loading: ${e.message}.`;
        // }
        this.dataSource = new CustomStore({
          loadMode: 'raw', // omit in the DataGrid, TreeList, PivotGrid, and Scheduler
          load: () => {
            this.yearlyDataGridInstance.beginCustomLoading();
            this.totalDataGridInstance.beginCustomLoading();
            return axios.get(this.endpoint)
                .then(response => {
                  this.dataSourceTotal = [response.data.total];
                  this.dataSourceYearly = response.data.yearly;
                  
                  return response.data.monthly;
                });
          }
        });
      } else {
        // const result = await axios.post(this.endpoint, this.selectedItemCodes);
        // this.dataSource = result.data.monthly;
        // this.dataSourceTotal = [result.data.total];
        // this.dataSourceYearly = result.data.yearly;

        this.dataSource = new CustomStore({
          loadMode: 'raw', // omit in the DataGrid, TreeList, PivotGrid, and Scheduler
          load: () => {
            this.yearlyDataGridInstance.beginCustomLoading();
            this.totalDataGridInstance.beginCustomLoading();
            return axios.post(this.endpoint, this.selectedItemCodes)
                .then(response => {
                  this.dataSourceTotal = [response.data.total];
                  this.dataSourceYearly = response.data.yearly;

                  return response.data.monthly;
                });
          }
        });
      }
      this.loading = false;
    },
    async fetchItemCodes() {
      const result = await axios.get("api/tables/itemCodes");
      this.itemCodesAllElementCount = result.data.length;
      // this.itemCodes = { store: result.data, pageSize: result.data.length }
      this.itemCodes = result.data;
    },
    saveListInstance: function(e) {
      this.listInstance = e.component;
    },
    saveRadioGroupInstance: function (e) {
      this.radioGroupInstance = e.component;      
    },
    onRadioGroupSelectionChanged: function (e) {
      if (this.radioGroupInstance.option('value') !== null) {
        this.listInstance.unselectAll();        
      }
      this.fetch();
    },    
    onSelectionChanged: function (e) {
      if (this.listInstance.option('selectedItems').length) {
        this.radioGroupInstance.option('value', null);
      }
      this.fetch();
    },
    jobMadeDateCellValue: function(data) {
      const month = data.jobMadeDate.substring(5, 7);
      const result = months.find(item => item.value === month);
      return data.jobMadeDate.substring(0, 4) + " " + result.name;
    },
    jobMadeDateCellValueForTotal: function(data) {
      return 'All Time';
    },
    jobMadeDateCellValueForYearly: function(data) {
      return data.jobMadeDate.substring(0, 4);
    },
    saveGridInstance: function(e) {
      this.dataGridInstance = e.component;
    },
    saveYearlyGridInstance: function(e) {
      this.yearlyDataGridInstance = e.component;
    },
    saveTotalGridInstance: function(e) {
      this.totalDataGridInstance = e.component;
    },
    onContentReady() {
      if(this.dataGridInstance.totalCount()) {
        this.yearlyDataGridInstance.endCustomLoading();
        this.totalDataGridInstance.endCustomLoading();
      }
    }
  }
}
</script>